/**
 * Arabic translations for company-related features.
 */

const company = {
  // Error messages per CONTEXT.md
  notMemberError: 'يجب أن تتم دعوتك من قبل الشركة',
  loadingCompany: 'جارٍ تحميل بيانات الشركة...',
  noCompany: 'أنت لست جزءًا من أي شركة',
  switchCompany: 'تبديل الشركة',

  // Role names
  roles: {
    owner: 'مالك',
    admin: 'مدير',
    agent: 'وكيل',
    viewer: 'مشاهد',
  },

  // Permission messages
  noPermission: 'ليس لديك صلاحية لهذا الإجراء',

  // Company info
  companyInfo: 'معلومات الشركة',
  teamMembers: 'أعضاء الفريق',
  usage: 'الاستخدام',
  listingsUsed: '{{used}} من {{max}} إعلان',
};

export default company;
